import { RootState } from "../../types";

export const organisationsSelector = (state: RootState) => state.organisations.organisations;
